import React from 'react';
import CategoryPage from '../components/CategoryPage';

const OfficeSpacePage = () => {
  return <CategoryPage categoryId="office-space" />;
};

export default OfficeSpacePage;